import * as React from 'react';
import { SVGProps } from 'react';
export const StatisticsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={13}
    viewBox="0 0 14 13"
    fill="none"
    {...props}
  >
    <path
      fill="#6E7384"
      d="M13 11.25h-.25V1.5A.75.75 0 0 0 12 .75H8.5a.75.75 0 0 0-.75.75v2.25H5a.75.75 0 0 0-.75.75v2.25H2a.75.75 0 0 0-.75.75v3.75H1a.75.75 0 1 0 0 1.5h12a.75.75 0 1 0 0-1.5Zm-3.75-9h2v9h-2v-9Zm-3.5 3h2v6h-2v-6Zm-3 3h1.5v3h-1.5v-3Z"
    />
  </svg>
);
